import React, { PureComponent } from 'react';
import {
  WithStyles,
  createStyles,
  withStyles,
  WithTheme,
  withTheme,
  Theme,
} from '@lifeomic/chroma-react/styles';
import SurveyItem from '../util/SurveyItem';
import clsx from 'clsx';

const styles = (theme: Theme) =>
  createStyles({
    root: {
      maxWidth: '100%',
      display: 'flex',
    },
    margins: {
      margin: theme.spacing(3, 0),
    },
    indented: {
      marginLeft: theme.spacing(8),
    },
    denseIndented: {
      marginLeft: theme.spacing(5),
    },
  });

export interface SurveyItemContainerOwnProps {
  children: any;
  surveyItem: SurveyItem;
}

export type SurveyItemContainerProps = SurveyItemContainerOwnProps &
  WithStyles<typeof styles> &
  WithTheme;

class SurveyItemContainer extends PureComponent<SurveyItemContainerProps> {
  render() {
    const isDense = this.props.surveyItem.hasDenseMargins;
    const isIndented = this.props.surveyItem.isIndented;

    const classes = [
      this.props.classes.root,
      isDense ? undefined : this.props.classes.margins,
    ].filter(Boolean);

    const indentationCount =
      (isDense ? 3 : 0) +
      (isIndented ? this.props.surveyItem.indentationCount : 0);

    const marginLeft = this.props.theme.spacing(indentationCount);

    return (
      <div className={clsx(...classes)} style={{ marginLeft }}>
        {this.props.children}
      </div>
    );
  }
}

export default withTheme(withStyles(styles)(SurveyItemContainer));
